import React from "react";

const VehicleRecommendationPanel = ({
  mapRef,
vehicles,
  orderedVehicles,
  activeVehicle,
  handleVehicleSelect,
  getVehicleMeta,
}) => {
  return (
    <div className="order-1 flex flex-col lg:order-2">
      <div className="order-1 flex h-[260px] bg-slate-100 p-3 sm:h-[350px] md:h-[450px] lg:order-2 lg:h-full lg:p-5">
        <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
          <div ref={mapRef} className="h-full w-full" />
        </div>
      </div>

        <div className="order-1 bg-[#fbf6e7] px-3 py-5 sm:px-6 sm:py-8 lg:order-2 lg:px-7 lg:py-5">
            <div className="mx-auto max-w-[420px]">
              <h4 className="mb-3 text-base font-bold text-gray-500">
                Recommended Vehicles
              </h4>

              <div className="space-y-4">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.name}
                    onClick={() => handleVehicleSelect(vehicle.name)}
                    className={`cursor-pointer overflow-hidden rounded-lg border bg-white transition ${
                      activeVehicle === vehicle.name
                        ? "border-orange-400 bg-orange-100"
                        : "border-gray-200 hover:border-orange-200"
                    }`}
                  >
                    <div
                      className={`flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${
                        activeVehicle === vehicle.name
                          ? "bg-orange-100"
                          : "bg-white"
                      }`}
                    >
                      <div className="flex w-full items-center gap-3">
                        <div className="flex h-16 w-16 items-center justify-center">
                          <img
                            src={vehicle.img}
                            alt={vehicle.name}
                            className="h-12 w-12 object-contain"
                          />
                        </div>

                        <div>
                          <h3 className="font-bold text-gray-800">
                            {vehicle.name}
                          </h3>

                          {activeVehicle === vehicle.name ? (
                            <div className="text-sm leading-5 text-gray-600">
                              <p>
                                <b>Weight:</b>{" "}
                                {getVehicleMeta(vehicle.vehicleId).weight}
                              </p>

                              <p>
                                <b>Dimension:</b>{" "}
                                {getVehicleMeta(vehicle.vehicleId).dimension}
                              </p>
                            </div>
                          ) : (
                            <p className="flex flex-col text-sm text-gray-500 sm:flex-row sm:gap-6">
                              <span>
                                W: {getVehicleMeta(vehicle.vehicleId).weight}
                              </span>

                              <span>
                                D: {getVehicleMeta(vehicle.vehicleId).dimension}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>

                      <h3 className="text-[18px] font-bold text-gray-900 sm:self-center sm:text-[20px]">
                        ₹{vehicle.price}
                      </h3>
                    </div>

                    {activeVehicle === vehicle.name && (
                      <div className="border-t border-orange-300 bg-white px-4 py-3 text-sm text-gray-500">
                        {vehicle.best}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
    </div>
  );
};

export default VehicleRecommendationPanel;